<div class="side-drawer-container" [ngStyle]="{ width: sideNavWidth + 'px' }">
  <mat-toolbar class="side-drawer-toolbar">
    <mat-toolbar-row>
      <div class="side-drawer-pre-title-actions">
        <ng-content select="automata-side-drawer-pre-title-actions"></ng-content>
      </div>
      <h1 class="side-drawer-toolbar-title">{{ title | translate }}</h1>
      <div class="side-drawer-title-actions">
        <ng-content select="automata-side-drawer-title-actions"></ng-content>
      </div>
      <ng-container>
        <button mat-icon-button *ngIf="!preventClose" (click)="closeSideDrawer()">
          <mat-icon>close</mat-icon>
        </button>
      </ng-container>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="side-drawer-content">
    <ng-content select="automata-side-drawer-content"></ng-content>
  </div>

  <footer class="right-panel-footer">
    <ng-content select="automata-side-drawer-footer"></ng-content>
  </footer>
  <div class="resize-handle" (mousedown)="startResizing($event)">
    <div class="handle-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g transform="rotate(90 12 12)">
          <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
        </g>
      </svg>
    </div>
  </div>
</div>
